import {ActionReducer, ActionReducerMap} from '@ngrx/store';
import * as fromDashboard from '../reducers/dashboard.reducer';
import {combineReducers} from '@ngrx/store';

export interface DashboardState {
  dashboard: fromDashboard.FreelancerState;
}

export const reducers: ActionReducerMap<DashboardState> = {
    dashboard: fromDashboard.reducer,
};

export const reducer: ActionReducer<DashboardState> = combineReducers(reducers);




// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/dashboard/store/reducers/index.ts